import { Box, Typography } from "@mui/material";

export const OrDivider = ({ text }: { text: string }) => {
  return (
    <Box
      width="100%"
      maxWidth="450px"
      display="flex"
      alignItems="center"
      marginY={2}
    >
      <Box flex={1} height="1px" bgcolor="rgba(255, 255, 255, 0.12)" />
      <Typography
        variant="body2"
        sx={{
          mx: 2,
          color: "text.secondary",
          whiteSpace: "nowrap"
        }}
      >
        {text}
      </Typography>
      <Box flex={1} height="1px" bgcolor="rgba(255, 255, 255, 0.12)" />
    </Box>
  );
};
